import styled from 'styled-components';
import { Layout } from 'src/viewLayer/components/DesignSystem';

export const CenteredLayout = styled(Layout)`
  margin: 12rem auto;
  text-align: center;
  width: 60%;
`;
